import { render, staticRenderFns } from "./OrderLoading.vue?vue&type=template&id=a2071f9c&scoped=true"
import script from "./OrderLoading.vue?vue&type=script&lang=js"
export * from "./OrderLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2071f9c",
  null
  
)

export default component.exports